<div class="markdown-editor-container">
  <div #editor [style.height]="height"></div>
</div>
